import React from "react";
import Gallery from "react-grid-gallery";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "./lightbox.css";

const formatCaption = (title, description, height) => {
    let descriptionList = Object.keys(description).map((key) => {
        if (key !== "threeD" && key !== "name" && key !== "img") {
            return <li>{key + " - " + description[key]}</li>;
        }
    });

    return (
        <div className="container-fluid" >
            <div className="row">
                <div className="lightboxCaption" >
                    <h6>{title}</h6>
                    <ul className="parameterList" > {descriptionList}</ul>
                </div>
            </div>
        </div>
    );
};

const createLightboxObjects = (data) => {
    let out = data.map((item) => {
        return {
            src: item.src,
            thumbnail: item.src,
            thumbnailWidth: 350,
            thumbnailHeight: 350,
            caption: formatCaption(item.title, item.description),
        };
    });
    return out;
};

class ImageComponent extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <LazyLoadImage
                height={this.props.imageProps.style.width}
                width={this.props.imageProps.style.width}
                src={this.props.imageProps.src}
            />
        );
    }
}

export default class DesignOptionGallery extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentImage: 0,
            images: createLightboxObjects(this.props.gridData),
            selectionImg: null,
            selectionDescription: null,
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ images: createLightboxObjects(nextProps.gridData) });
    }

    render() {
        return (
            <div>
                <Gallery
                    lightboxWidth={this.props.imageWidth}
                    images={this.state.images}
                    thumbnailImageComponent={ImageComponent}
                    rowHeight={350}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/DesignOptionGallery/DesignOptionGallery.js